export default function withoutSensitiveFields(object) {
  if (typeof object !== 'object' || !object) {
    return object;
  }
  const newObject = {};
  for (const key of Object.keys(object)) {
    newObject[key] = key.toLowerCase().includes('password')
      ? '*PRIVATE*'
      : object[key];
  }
  return newObject;
}
